/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditSpotAuditSpotMatchesCreateManualMutationRequest, AuditSpotAuditSpotMatchesCreateManualMutationResponse, AuditSpotAuditSpotMatchesCreateManualQueryParams } from "../models/AuditSpotAuditSpotMatchesCreateManual";

export function getAuditSpotAuditSpotMatchesCreateManualUrl() {
  const res = { method: 'POST', url: `/audit-spot/v1/matches/create-manual` as const }
  return res
}

/**
 * @description Creates a manual spot match for a station.
 * @summary Create manual match
 * {@link /audit-spot/v1/matches/create-manual}
 */
export async function auditSpotAuditSpotMatchesCreateManual(data: AuditSpotAuditSpotMatchesCreateManualMutationRequest, params: AuditSpotAuditSpotMatchesCreateManualQueryParams, config: Partial<RequestConfig<AuditSpotAuditSpotMatchesCreateManualMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AuditSpotAuditSpotMatchesCreateManualMutationResponse, ResponseErrorConfig<Error>, AuditSpotAuditSpotMatchesCreateManualMutationRequest>({ method : "POST", url : getAuditSpotAuditSpotMatchesCreateManualUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}